import { Delete, KeyboardArrowLeft, KeyboardArrowRight, UploadFile } from '@mui/icons-material';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useMemo, useRef, useState } from 'react';
import { DropzoneArea } from 'react-mui-dropzone';
import { useSelector } from 'react-redux';
import { getRealmName } from 'src/routes/AuthContext';
import { getUploadFilesizeLimit } from 'src/services/documentService/getUploadFilesizeLimit';

type Props = {
  activeStep: any;
  handleBack: any;
  setUploadedDoc: any;
  handleMultiFileUpload: () => void;
  files: File[];
  handelNavigateBack: any;
};

const UploadHospitalRecords = (props: Props) => {
  const { activeStep, handleBack, setUploadedDoc, handleMultiFileUpload, files, handelNavigateBack } = props;
  const saveMiscDocResponse = useSelector((state: any) => state.saveMiscellaneousDocumentsReducer);
  const realm = getRealmName() || '';
  const facilityId = localStorage.getItem('facilityId') || '';
  const dropzoneRef = useRef<any>(null);
  const [fileSizeLimit, setFileSizeLimit] = useState<number | null>(null);

  useEffect(() => {
    if(fileSizeLimit === null) {
      getUploadFilesizeLimit(realm, facilityId).then((limitResponse) => {
        setFileSizeLimit(limitResponse);
      })
    }
  }, [realm, fileSizeLimit, facilityId]);

  const handleMultipleFileSelect = (files: File[]) => {
    setUploadedDoc(files);
  }

  const handleRemoveFile = (removeFile: File, index: number) => {
    dropzoneRef?.current?.deleteFile(removeFile, index);
  };

  const docLoop = Array.isArray(files) ? files.map((file, index) => {
    return (
      <TableRow key={`hospital-record-${index}`}>
        <TableCell>{file?.name}</TableCell>
        <TableCell>{(file.size / 1024).toFixed(2)} KB</TableCell>

        <TableCell>
          <IconButton
            edge="end"
            aria-label="delete"
            title="Remove file"
            onClick={() => handleRemoveFile(file, index)}
          >
            <Delete />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  }) : [];

  const hasDocuments = docLoop.length;

  return (
    <>
      <Box
        sx={{
          border: '1px solid #F2F4F7',
          borderRadius: '20px',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
        p={1}
      >
        <Box sx={{ p: 5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Typography variant="h6">Hospital Record</Typography>

            {fileSizeLimit === null ? <></> : (
              <DropzoneArea
                ref={dropzoneRef}
                acceptedFiles={['.pdf']}
                sx={{
                  borderRadius: '50px',
                  borderColor: '#6C737F',
                  width: '70%',
                  color: '#6C737F',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onChange={handleMultipleFileSelect}
                dropzoneText="Drag & Drop or Click here To Browse"
                showFileNames={true}
                Icon={(props: any) => null}
                showAlerts={false}
                showPreviews={false}
                showPreviewsInDropzone={false}
                maxFileSize={fileSizeLimit}
                filesLimit={10}
              />
            )}

            <Table sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Document Name</TableCell>
                  <TableCell>File Size</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                
                {hasDocuments ? (
                  <>
                    {docLoop}
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Box
                        textAlign="center"
                        p={3}
                      >
                        <Typography
                          color={'text.secondary'}
                          variant="subtitle2"
                        >
                          No File Selected
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Box>
            <Button
              variant="outlined"
              disabled={activeStep === 0}
              startIcon={<KeyboardArrowLeft />}
              onClick={handleBack}
            >
              Back
            </Button>
          </Box>

          <Box>
            <Button
              sx={{ mr: 2, color: '#384250' }}
              onClick={handelNavigateBack}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={<UploadFile />}
              onClick={handleMultiFileUpload}
              disabled={saveMiscDocResponse?.loading || !hasDocuments}
            >
              Upload File
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UploadHospitalRecords;
